// src/context/FeatureExpandContext.jsx
import React, { createContext, useContext, useState } from 'react';

const FeatureExpandContext = createContext(null);

export function FeatureExpandProvider({ children }) {
  const [expandedFeatures, setExpandedFeatures] = useState(new Set());
  const [allExpanded, setAllExpanded] = useState(false);

  const expandAll = () => {
    setAllExpanded(true);
  };

  const collapseAll = () => {
    setExpandedFeatures(new Set());
    setAllExpanded(false);
  };

  const toggleFeature = (featureRef) => {
    setExpandedFeatures(prev => {
      const newSet = new Set(prev);
      if (newSet.has(featureRef)) {
        newSet.delete(featureRef);
      } else {
        newSet.add(featureRef);
      }
      return newSet;
    });
  };

  const isExpanded = (featureRef) => {
    return allExpanded || expandedFeatures.has(featureRef);
  };

  return (
    <FeatureExpandContext.Provider 
      value={{
        isExpanded,
        expandAll,
        collapseAll,
        toggleFeature,
        allExpanded
      }}
    >
      {children}
    </FeatureExpandContext.Provider>
  );
}

export function useFeatureExpand() {
  const context = useContext(FeatureExpandContext);
  if (!context) {
    throw new Error('useFeatureExpand must be used within a FeatureExpandProvider');
  }
  return context;
}